module.exports = __webpack_public_path__ + "img/geo.e2be4ffc.svg";